import { render } from "./Tabla-Bitacora.vue?vue&type=template&id=3f65b4f5&scoped=true"
import script from "./Tabla-Bitacora.vue?vue&type=script&lang=js"
export * from "./Tabla-Bitacora.vue?vue&type=script&lang=js"

import "./Tabla-Bitacora.vue?vue&type=style&index=0&id=3f65b4f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65b4f5"]])

export default __exports__